
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.764 17.295H.654a.653.653 0 010-1.307h16.11a.653.653 0 010 1.307z"}}),_c('path',{attrs:{"d":"M8.848 17.295a.653.653 0 01-.461-1.116l7.985-7.985c.208-.208.322-.48.322-.766a1.09 1.09 0 00-.322-.775l-4.276-4.276a1.061 1.061 0 00-.775-.321c-.291 0-.562.112-.761.317l-8.931 8.93a1.058 1.058 0 00-.323.776c0 .29.113.562.317.76l3.34 3.341a.654.654 0 01-.923.925L.704 13.769A2.349 2.349 0 010 12.08c0-.652.253-1.257.71-1.704l8.921-8.92c.886-.91 2.504-.908 3.394.005l4.27 4.27a2.386 2.386 0 010 3.388l-7.986 7.986a.648.648 0 01-.461.191z"}}),_c('path',{attrs:{"d":"M13.604 12.54a.648.648 0 01-.462-.192l-6.74-6.74a.653.653 0 11.924-.924l6.74 6.74a.653.653 0 01-.462 1.116z"}})])
          )
        }
      }
    